/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";

const ContactMap = () => {
  return (
    <div className="contact_map_area">
      <div className="row mt_100 xs_mt_70">
        <div className="col-12 wow fadeInUp" data-wow-duration="1s">
          <div className="contact_map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2686.4717015194583!2d-117.36707512376132!3d47.67525858323404!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x549e1f35519bbe5b%3A0x93015d3bb8888a4e!2s3118%20E%20Baldwin%20Ave%2C%20Spokane%2C%20WA%2099207%2C%20USA!5e0!3m2!1sen!2s!4v1738061381878!5m2!1sen!2s"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactMap;
